import { Fragment } from "react";
import style from "./403.module.css";

function Layout403() {
  return (
    <Fragment>
      <div
        className={"rtl-all position-relative overflow-hidden " + style.keeper}
      >
        <h1
          className={[style["police-tape"], style["police-tape--1"]].join(" ")}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;خطا:
          403&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;خطا:
          403&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;خطا:
          403&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;خطا:
          403&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;خطا:
          403&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;خطا:
          403&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;خطا: 403
        </h1>
        <h1
          className={[style["police-tape"], style["police-tape--2"]].join(" ")}
        >
          ممنوع&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ممنوع&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ممنوع&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ممنوع&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ممنوع&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ممنوع&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </h1>

        <p className={style.info}>اجازه ی دسترسی ندارید</p>
      </div>
    </Fragment>
  );
}

export default Layout403;
